<template>
<v-layout
    justify-center
    style="background-color: #000"
>
  <v-flex style="max-width: 1430px">
    <v-parallax
        src="/static/images/background.png"
        height="auto"
        style="min-height: 400px"
    >
      <v-layout
          align-center
          column
      >
        <img src="/static/images/logo.svg" alt="" class="header-logo" />
        <h1 class="header-title">
          {{ $t('header.title') }}
          <img src="/static/images/elei.svg" alt="" />
        </h1>
        <transition name="component-fade">
          <div
              v-if="dialog"
              v-html="$t('header.description')"
              class="header-subtext"
          ></div>
        </transition>
        <v-btn
            outline
            dark
            round
            large
            color="#0038A8"
            class="btn-header mb-3"
            @click="dialog = !dialog"
        >
          {{ dialog ? $t('header.less') : $t('header.more') }}
        </v-btn>
      </v-layout>
    </v-parallax>
  </v-flex>
</v-layout>
</template>

<script>
export default {
  name: 'headerComponent',
  data () {
    return {
      dialog: false
    }
  }
}
</script>

<style lang="scss">
.header-logo {
  height: 65px;
  margin-top: 37px;
}
.header-title {
  font-size: 48px;
  font-weight: 700;
  line-height: 57px;
  margin-top: 44px;

  img {
    height: 57px;
    vertical-align: middle;
  }
}
.btn-header {
  font-weight: bold;
  text-transform: capitalize;
  margin-top: 20px;
}

@media only screen and (max-width: 768px) {
  .header-title {
    font-size: 30px;
    line-height: 35px;
    text-align: center;

    img {
      height: 35px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/partials/header.vue